// extracted by mini-css-extract-plugin
export default {"landing-video":"landing-video_landing-video__ErBy5","carousel-root":"landing-video_carousel-root__SxeWR"};